import { render, staticRenderFns } from "./ConsultNew.vue?vue&type=template&id=43fef7eb&"
import script from "./ConsultNew.vue?vue&type=script&lang=js&"
export * from "./ConsultNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports